import classNames from 'classnames';
import React from 'react';
import {
	useSelector,
} from 'react-redux';
import {
	Link,
} from 'react-router5';

import {
	selectedSectionSelector,
} from '~/state/ui/selectors';

import useNavigationLinkClick from '~/hooks/useNavigationLinkClick';

import {
	type RenderProp,
	renderProp,
} from '~/utilities/renderProp';



type ChildProps = {
	isActive: boolean,
	isDimmed: boolean,
};

type Props = {
	children: RenderProp<ChildProps>,
	className?: string,
	onClick?: () => void,
};

/**
 * Link to General Admin - used in Internal nav section.
 * Provides isActive when current route is generalAdmin or any sub-route.
 */
const GeneralAdminLink: React.FC<Props> = (props) => {
	const {
		children,
		className,
		onClick,
	} = props;

	const selectedSection = useSelector(selectedSectionSelector);
	const handleClick = useNavigationLinkClick(onClick);

	const isActive = selectedSection === 'generalAdmin';

	const finalClassName = classNames({
		'active': isActive,
	}, className);

	return (
		<Link
			className={finalClassName}
			onClick={handleClick}
			routeName="generalAdmin"
		>
			{renderProp(
				children,
				{
					isActive,
					isDimmed: false,
				},
			)}
		</Link>
	);
};



export default GeneralAdminLink;
